import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconEyeClosed = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 13",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.6321 3.50033C13.3448 5.88432 10.8575 7.49996 8.00004 7.49996M8.00004 7.49996C5.14258 7.49996 2.65518 5.88432 1.36825 3.5M8.00004 7.49996V9.5M13.4688 5.11444L15 6.49993M11.1172 6.81241L12.0527 8.49998M2.53125 5.11444L1 6.49993M4.88283 6.81241L3.94738 8.49998",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconEyeClosed;
